<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary darken-2" dark>
    <v-toolbar-title style="width: 300px;" class="ml-0 pl-4">
      <v-app-bar-nav-icon @click.stop="$emit('update:drawer', !drawer)"></v-app-bar-nav-icon>
      <span class="hidden-sm-and-down">Danapay</span>
    </v-toolbar-title>
    <v-text-field
      flat
      solo-inverted
      hide-details
      prepend-inner-icon="mdi-magnify"
      label="Search"
      class="hidden-sm-and-down"
    ></v-text-field>
    <div class="flex-grow-1"></div>
    <v-btn icon>
      <v-icon>mdi-apps</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>mdi-bell</v-icon>
    </v-btn>
    <v-menu offset-y left bottom link>
      <template v-slot:activator="{ attrs, on }" link>
        <v-btn icon large>
          <v-avatar color="grey" size="40" class="ml-1 clickable" v-bind="attrs" v-on="on">
            <span class="title">DP</span>
          </v-avatar>
        </v-btn>
      </template>

      <v-card>
        <v-list dense>
          <v-list-item to="/configurations">
            <v-list-item-icon>
              <v-icon>mdi-cogs</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Configurations</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>
<script>
import get from "lodash/get";
export default {
  props: {
    drawer: {
      required: true,
    },
  },
  methods: {
    logout() {
      this.$http
        .post("/api/v1/auth/logout")
        .then(() => {
          // remove the token
          this.$http.setAuthenticationToken();
          // eslint-disable-next-line no-unused-vars
          this.$router.push({ name: "auth.login" }).catch((error) => {});
        })
        .catch((error) => {
          const message = get(
            error,
            " response.data.message",
            "Something went wrong while logging out",
          );
          Notify.warning(message);
        });
    },
  },
};
</script>
